<div class="input">
  <clear-all-fields-button *ngIf="stateTaxRatesFromBXR" (clearAll)="onClearAllFields()"></clear-all-fields-button>

  <div class="input-column">
    <div class="button-container-conv" id="rothConversionAmountLabel">
      <span>{{ rothConvDetails?.rothConvAmnt }}</span>
    </div>
    <ngx-input-number
      inputType="dollar"
      designType='compact'
      [ariaLabelId]="'rothConversionAmountLabel'"
      [id]="'rothConversionAmountInput'"
      [currentValue]="_rothConversionAmount.toString()"
      [hintText]="rothConversionAmountHintText"
      [errorText]="rothConversionAmountErrorMessage"
      (click)="rothConversionAmountClicked()"
      (onInputChange)="onRothConversionAmountChange($event)"
    ></ngx-input-number>
  </div>

  <div class="input-column">
    <div id="yearsUntilDistLabel" class="button-container-conv">
      <span>{{ rothConvDetails?.yearsUntilDist }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16" (click)="infoIconOnClick('rothConversion', 'sheet-field-years-until')"></ngx-axs-icon>
    </div>
    <ngx-input-number
      designType='compact'
      [ariaLabelId]="'yearsUntilDistLabel'"
      [id]="'yearsUntilDistInput'"
      [currentValue]="_yearsUntilDist.toString()"
      [hintText]="rothConvDetails?.yearsDistLabel"
      [errorText]="yearsUntilDistErrorMessage"
      (onInputChange)="onYearsUntilDistChange($event)"
    ></ngx-input-number>
  </div>

  <div class="input-column">
    <div class="button-container-conv">
      <span>{{ rothConvDetails?.paymentMethodConvTax }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16"
        (click)="infoIconOnClick('rothConversion', 'sheet-field-payment-method')"></ngx-axs-icon>
    </div>
    <axs-select-dropdown-beta
      #paymentMethodDropdown
      axs-size="small"
      axs-design-type="outlined"
      axs-aria-label="Payment method for conversion tax"
      [attr.axs-value]="_paymentMethod"
      (axs-change)="onPaymentMethodChange($any(paymentMethodDropdown).getValue())"
    >
      <axs-select-dropdown-option-beta axs-value="" axs-disabled>Select one</axs-select-dropdown-option-beta>
      @for (option of paymentMethodDropdownOptions; track option.value) {
        <axs-select-dropdown-option-beta [attr.axs-value]="option.value">{{ option.label }}</axs-select-dropdown-option-beta>
      }
    </axs-select-dropdown-beta>
  </div>

  <div class="conditional-fields">
    <!-- Annual return: ALWAYS visible -->
    <div class="input-column">
    <div id="annualReturnLabel" class="button-container-conv">
      <span>{{ rothConvDetails?.annualReturn }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16"
        (click)="infoIconOnClick('rothConversion', 'sheet-field-annual-return')"></ngx-axs-icon>
    </div>
    <ngx-input-number
      inputType='percent'
      designType='compact'
      [ariaLabelId]="'annualReturnLabel'"
      [id]="'annualReturnInput'"
      [decimalAmount]="2"
      [currentValue]="_annualReturn.toString()"
      [hintText]="rothConvDetails?.yearsDistLabel"
      [errorText]="annualReturnErrorMessage"
      (onInputChange)="onAnnualReturnChange($event)"
    ></ngx-input-number>
  </div>

  <!-- Cash yield: shown only if Cash payment -->
    <div *ngIf="_paymentMethod === 'cash'" class="input-column">
    <div id="cashYieldLabel" class="button-container-conv">
      <span>{{ rothConvDetails?.cashYield }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16"
        (click)="infoIconOnClick('rothConversion', 'sheet-field-cash-yield')"></ngx-axs-icon>
    </div>
    <ngx-input-number
      inputType='percent'
      designType='compact'
      [ariaLabelId]="'cashYieldLabel'"
      [id]="'cashYieldInput'"
      [decimalAmount]="2"
      [currentValue]="_cashYield.toString()"
      [hintText]="rothConvDetails?.cashYieldLabel"
      [errorText]="cashYieldErrorMessage"
      (onInputChange)="onCashYieldChange($event)"
    ></ngx-input-number>
  </div>

  <!-- Dividend tax rate, Capital gains tax rate, Dividend yield: shown only if Tax-efficient -->
    <ng-container *ngIf="_paymentMethod === 'tax-efficient'">
    <div class="input-column">
      <div id="dividendTaxRateLabel" class="button-container-conv">
        <span>{{ rothConvDetails?.dividendRate }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16"
          (click)="infoIconOnClick('rothConversion', 'sheet-field-dividend-tax')"></ngx-axs-icon>
      </div>
      <ngx-input-number
        inputType='percent'
        designType='compact'
        [ariaLabelId]="'dividendTaxRateLabel'"
        [id]="'dividendTaxRateInput'"
        [decimalAmount]="2"
        [currentValue]="_dividendTaxRate.toString()"
        [defaultValue]="defaultDividendTaxRate"
        [differsText]="rateDiffersText"
        [differsLinkText]="rateDiffersLinkText"
        [differsLink]="'https://advisors.vanguard.com/content/dam/fas/pdfs/FATXGD11.pdf'"
        [hintText]="rothConvDetails?.taxableAccountLabel"
        [errorText]="dividendTaxRateErrorMessage"
        (onInputChange)="onDividendTaxRateChange($event)"
      ></ngx-input-number>
    </div>

    <div class="input-column">
      <div id="capitalGainsTaxRateLabel" class="button-container-conv">
        <span>{{ rothConvDetails?.capitalGainsRate }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16"
          (click)="infoIconOnClick('rothConversion', 'sheet-field-capital-gains-tax')"></ngx-axs-icon>
      </div>
      <ngx-input-number
        inputType='percent'
        designType='compact'
        [ariaLabelId]="'capitalGainsTaxRateLabel'"
        [id]="'capitalGainsTaxRateInput'"
        [decimalAmount]="2"
        [currentValue]="_capitalGainsTaxRate.toString()"
        [defaultValue]="defaultCapitalGainsTaxRate"
        [differsText]="rateDiffersText"
        [differsLinkText]="rateDiffersLinkText"
        [differsLink]="'https://advisors.vanguard.com/content/dam/fas/pdfs/FATXGD11.pdf'"
        [hintText]="rothConvDetails?.taxableAccountLabel"
        [errorText]="capitalGainsTaxRateErrorMessage"
        (onInputChange)="onCapitalGainsTaxRateChange($event)"
      ></ngx-input-number>
    </div>

    <div class="input-column">
      <div id="dividendYieldLabel" class="button-container-conv">
        <span>{{ rothConvDetails?.dividendYield }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16"
          (click)="infoIconOnClick('rothConversion', 'sheet-field-dividend-yield')"></ngx-axs-icon>
      </div>
      <ngx-input-number
        inputType='percent'
        designType='compact'
        [ariaLabelId]="'dividendYieldLabel'"
        [id]="'dividendYieldInput'"
        [decimalAmount]="2"
        [currentValue]="_dividendYield.toString()"
        [hintText]="rothConvDetails?.cashYieldLabel"
        [errorText]="dividendYieldErrorMessage"
        (onInputChange)="onDividendYieldChange($event)"
      ></ngx-input-number>
    </div>
    </ng-container>
  </div>

  <div class="input-column">
    <div id="percentOfIraLabel" class="button-container-conv">
      <span>{{ rothConvDetails?.percentOfIra }}</span><ngx-axs-icon axsType="questionOutline" axsWidth="16" axsHeight="16"
        (click)="infoIconOnClick('rothConversion', 'sheet-field-percent-of-ira')"></ngx-axs-icon>
    </div>
    <ngx-input-number
      inputType='percent'
      designType='compact'
      [ariaLabelId]="'percentOfIraLabel'"
      [id]="'percentOfIraInput'"
      [decimalAmount]="1"
      [currentValue]="_percentOfIra.toString()"
      [hintText]="rothConvDetails?.iraLabel"
      [errorText]="percentOfIraErrorMessage"
      (onInputChange)="onPercentOfIraChange($event)"
    ></ngx-input-number>
  </div>
</div>
